// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uploadH4 {
  font-size: 18px;
  margin-bottom: 10px;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: #797979;
  margin-top: 25px;
  margin-left: 8%;
  width: 213px;
}

.uploadPDFIcon {
  font-size: 24px;
  padding-top: 0px;
  vertical-align: middle;
}

.fileUploadQue {
  display: flex;
}

.dropdownDivQue {
  display: flex;
  margin-top: 5px;
}

.dropdownLabelQue {
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 4%;
  width: 180px;
  margin-left: 8%;
}

.dropdownSelectQue {
  box-sizing: border-box;
  width: 52%;
  position: relative;
  max-height: 35px;
  padding-right: 15px;
  padding-left: 15px;
  color: #555;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  line-height: 1.42857143;
  margin-left: 3.6%;
  margin-right: 10.8%;
  border-radius: 4px;
  border: 1px solid #ccc;
  outline-color: #68dff0;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.fileChooseQue {
  box-sizing: border-box;
  width: 52%;
  position: relative;
  max-height: 35px;
  font-family: "Ruda", sans-serif;
  margin-left: 4%;
  margin-right: 11%;
  margin-top: 25px;
  border-radius: 4px;
  outline-color: #68dff0;
  margin-bottom: 20px;
  color: #fff;
  background-color: #68dff0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid #48bcb4;
  padding: 6px 12px;
  cursor: pointer;
}

.fileChooseQueNot {
  box-sizing: border-box;
  width: 52%;
  position: relative;
  max-height: 35px;
  font-family: "Ruda", sans-serif;
  margin-left: 4%;
  margin-right: 11%;
  margin-top: 25px;
  border-radius: 4px;
  outline-color: #68dff0;
  margin-bottom: 20px;
  color: #fff;
  background-color: #68dff0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid #48bcb4;
  padding: 6px 12px;
  cursor: not-allowed;
}

canvas {
  width: 150px !important;
  height: 150px !important;
}

.thumbnailContainerUpload {
  padding: 5px;
  position: relative;
  left: 38.4%;
  width: 60%;
}

.imgUploadThumbnail {
  border-radius: 8px;
  height: 200px;
  width: 250px;
}

.uploadFileText {
  height: 200px;
  width: 75%;
}

.loadingDiv {
  display: inline-flex;
  height: 30px;
  width: 290px;
  position: absolute;
}

.reactLoadingIcon {
  height: 25px !important;
  margin-left: 10px;
  width: 30px !important;
  margin-right: 18px;
}

.loadingText {
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 4%;
  width: 180px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Screens/UploadQuestions/UploadQuestions.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,wEAAwE;AAC1E;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".uploadH4 {\n  font-size: 18px;\n  margin-bottom: 10px;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: #797979;\n  margin-top: 25px;\n  margin-left: 8%;\n  width: 213px;\n}\n\n.uploadPDFIcon {\n  font-size: 24px;\n  padding-top: 0px;\n  vertical-align: middle;\n}\n\n.fileUploadQue {\n  display: flex;\n}\n\n.dropdownDivQue {\n  display: flex;\n  margin-top: 5px;\n}\n\n.dropdownLabelQue {\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 4%;\n  width: 180px;\n  margin-left: 8%;\n}\n\n.dropdownSelectQue {\n  box-sizing: border-box;\n  width: 52%;\n  position: relative;\n  max-height: 35px;\n  padding-right: 15px;\n  padding-left: 15px;\n  color: #555;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  line-height: 1.42857143;\n  margin-left: 3.6%;\n  margin-right: 10.8%;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  outline-color: #68dff0;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n\n.fileChooseQue {\n  box-sizing: border-box;\n  width: 52%;\n  position: relative;\n  max-height: 35px;\n  font-family: \"Ruda\", sans-serif;\n  margin-left: 4%;\n  margin-right: 11%;\n  margin-top: 25px;\n  border-radius: 4px;\n  outline-color: #68dff0;\n  margin-bottom: 20px;\n  color: #fff;\n  background-color: #68dff0;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  cursor: pointer;\n  -webkit-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid #48bcb4;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.fileChooseQueNot {\n  box-sizing: border-box;\n  width: 52%;\n  position: relative;\n  max-height: 35px;\n  font-family: \"Ruda\", sans-serif;\n  margin-left: 4%;\n  margin-right: 11%;\n  margin-top: 25px;\n  border-radius: 4px;\n  outline-color: #68dff0;\n  margin-bottom: 20px;\n  color: #fff;\n  background-color: #68dff0;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  cursor: pointer;\n  -webkit-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid #48bcb4;\n  padding: 6px 12px;\n  cursor: not-allowed;\n}\n\ncanvas {\n  width: 150px !important;\n  height: 150px !important;\n}\n\n.thumbnailContainerUpload {\n  padding: 5px;\n  position: relative;\n  left: 38.4%;\n  width: 60%;\n}\n\n.imgUploadThumbnail {\n  border-radius: 8px;\n  height: 200px;\n  width: 250px;\n}\n\n.uploadFileText {\n  height: 200px;\n  width: 75%;\n}\n\n.loadingDiv {\n  display: inline-flex;\n  height: 30px;\n  width: 290px;\n  position: absolute;\n}\n\n.reactLoadingIcon {\n  height: 25px !important;\n  margin-left: 10px;\n  width: 30px !important;\n  margin-right: 18px;\n}\n\n.loadingText {\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 4%;\n  width: 180px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
